import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import MedignitionIcon from '@/assets/svg/MedignitionIcon';
import { useMobileDetect } from '@/utils/hooks';
import Icon from '@/components/AnimateCross';

import {
  Container,
  Wrapper,
  IconWrapper,
  Panel,
  StyledLink,
  LangBox,
  MenuButton,
  ButtonTitle,
} from './styles';

const Header = ({ isOpenMenu, toggleMenu, uri }) => {
  const { t } = useTranslation('app');
  const handleClick = useCallback(() => {
    toggleMenu(!isOpenMenu);
  }, [isOpenMenu, toggleMenu]);
  const isMobile = useMobileDetect();

  const shouldShowContactLinks = useMemo(() => uri === '/' || !isMobile, [isMobile, uri]);

  return (
    <Container>
      <Wrapper>
        <IconWrapper to="/" aria-label="medignition">
          <MedignitionIcon />
        </IconWrapper>
        <Panel>
          {shouldShowContactLinks && (
            <>
              <StyledLink
                to="/contacts/investors"
                selected={uri === '/contacts/investors'}
              >
                {t('investors')}
              </StyledLink>
              <StyledLink
                to="/contacts/partners"
                selected={uri === '/contacts/partners'}
              >
                {t('partners')}
              </StyledLink>
            </>
          )}
          <LangBox />
          <MenuButton id="menuButton" onClick={handleClick}>
            <ButtonTitle>{t('menu')}</ButtonTitle>
            <Icon isOpen={isOpenMenu} />
          </MenuButton>
        </Panel>
      </Wrapper>
    </Container>
  );
};

Header.propTypes = {
  isOpenMenu: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  uri: PropTypes.string.isRequired,
};

export default Header;
